var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('div',{attrs:{"id":"error-container"}},_vm._l((_vm.errors),function(error){return _c('b-alert',{key:error,attrs:{"variant":"dark","show":"","dismissible":""}},[_vm._v(_vm._s(error))])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }